var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderCloud(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 4.8 4.8 0 24 0C43.2 0 48 4.8 48 24C48 43.2 43.2 48 24 48C4.8 48 0 43.2 0 24Z",
    fill: "#8282FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9849 22.2594C38.9549 21.5394 38.8349 20.8344 38.6099 20.1594C37.5749 16.9194 34.5449 14.5794 30.9749 14.5794H26.7899C25.9199 14.5794 25.8599 14.4894 25.3949 13.8744L23.2949 11.0844C22.3199 9.77937 21.5549 8.98438 19.1099 8.98438H15.6148C11.9548 8.98438 8.98486 11.9544 8.98486 15.6144V20.1444V30.9594C8.98486 35.3844 12.5849 38.9844 17.0099 38.9844H30.9599C35.3849 38.9844 38.9849 35.3844 38.9849 30.9594V22.5894C38.9999 22.4994 38.9999 22.3644 38.9849 22.2594Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3698 35.5498C26.2048 35.7748 26.2048 40.3648 29.3698 40.5898H36.8849C37.7999 40.5898 38.6698 40.2598 39.3448 39.6448C41.5648 37.7098 40.3798 33.8098 37.4548 33.4498C36.4048 27.1198 27.2398 29.5198 29.4148 35.5498",
    fill: "#111827"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderCloud);
export default __webpack_public_path__ + "static/media/folderCloud.5d8ccd5de450818e3aaff8cf7db94b32.svg";
export { ForwardRef as ReactComponent };